module.exports = __webpack_public_path__ + "img/PRNT_06_mono_AE_00002.83d699f0.png";